/* Fixed-quantity Recharge plans only. Theme UI guard, not server-side validation. */
(() => {
  let items = [], refreshing, refreshAgain = false, replay = false;
  const quantityFor = item => {
    const option = item.selling_plan_allocation?.selling_plan?.options?.find(o => o.name === 'Product Quantity');
    const value = Number(option?.value);
    return Number.isInteger(value) && value > 0 ? value : null;
  };
  const path = url => { try { return new URL(url, location.origin).pathname; } catch { return ''; } };
  const itemFor = row => {
    const key = row.querySelector('[data-quantity-line-key]')?.dataset.quantityLineKey;
    if (key) return items.find(item => item.key === key);
    const title = row.querySelector('.rebuy-cart__flyout-item-product-title');
    const frequency = row.querySelector('.rebuy-cart__flyout-item-property--delivery-frequency')?.textContent.trim();
    return items.find(item => path(item.url) === path(title?.href) && item.selling_plan_allocation?.selling_plan?.name === frequency);
  };
  function render() {
    document.body.toggleAttribute('data-caene-fixed-subscription-cart', items.some(quantityFor));
    document.querySelectorAll('.rebuy-cart__flyout-item, .cart-item').forEach(row => {
      const item = itemFor(row), quantity = item && quantityFor(item);
      const controls = row.querySelectorAll('.rebuy-cart__flyout-item-quantity-widget-button, .rebuy-cart__flyout-item-quantity input, .rebuy-cart__flyout-item-quantity select, quantity-input button, quantity-input input');
      if (!quantity) {
        delete row.dataset.caeneFixedPlan;
        row.querySelector('.caene-fixed-plan-note')?.remove();
        controls.forEach(control => {
          if (!control.hasAttribute('data-caene-quantity-locked')) return;
          control.disabled = control.dataset.caeneQuantityLocked === 'true';
          control.removeAttribute('data-caene-quantity-locked');
        });
        return;
      }
      row.dataset.caeneFixedPlan = String(quantity);
      controls.forEach(control => {
        if (!control.hasAttribute('data-caene-quantity-locked')) control.dataset.caeneQuantityLocked = String(control.disabled);
        control.disabled = true;
      });
      let note = row.querySelector('.caene-fixed-plan-note');
      if (!note) {
        note = document.createElement('p'); note.className = 'caene-fixed-plan-note';
        (row.querySelector('.rebuy-cart__flyout-item-info, .cart-item__details') || row).append(note);
      }
      const message = `${quantity} ${quantity === 1 ? 'pouch' : 'pouches'} per delivery. To change your delivery option, remove this item and choose again on the product page.`;
      if (note.textContent !== message) note.textContent = message;
    });
  }
  async function refresh() {
    if (refreshing) { refreshAgain = true; return refreshing; }
    refreshing = fetch(`${window.Shopify?.routes?.root || '/'}cart.js`, {credentials:'same-origin',cache:'no-store'})
      .then(response => { if (!response.ok) throw new Error('Cart unavailable'); return response.json(); })
      .then(cart => { items = cart.items; render(); return cart; });
    try { return await refreshing; }
    finally { refreshing = null; if (refreshAgain) { refreshAgain = false; refresh().catch(() => {}); } }
  }
  function showError(message, checkout) {
    let node = document.getElementById('caene-plan-cart-error');
    if (!node) {
      node = document.createElement('p');node.id = 'caene-plan-cart-error';node.className = 'caene-fixed-plan-error';node.setAttribute('role','alert');node.tabIndex = -1;
      (checkout || document.body).insertAdjacentElement(checkout ? 'beforebegin' : 'beforeend', node);
    }
    node.textContent = message; node.focus();
  }
  /* Complimentary gift safety net (order #1045: gift earned in Smart Cart, missing at checkout).
     Rebuy still adds and removes the tier gift. Only when Rebuy's own tier calculation says it is
     earned, the fresh cart agrees, the gift line is absent and the customer has not declined it,
     the same line is restored before checkout. Any failure falls through to checkout unchanged. */
  async function ensureGift(cart) {
    try {
      const smartCart = window.Rebuy?.SmartCart, tiers = smartCart?.progressBar?.tiers;
      if (!Array.isArray(tiers) || typeof smartCart.progressTierReached !== 'function') return;
      if (Number(window.Shopify?.currency?.rate || 1) !== 1) return;
      const declined = String(cart.attributes?._r_declined_gifts || '').split(',').map(value => value.trim());
      const gifts = [];
      tiers.forEach(tier => {
        if (tier.type !== 'product' || !(Number(tier.minimum) > 0)) return;
        let reached = false;
        try { reached = smartCart.progressTierReached(tier) === true; } catch { return; }
        if (!reached || cart.items_subtotal_price < Number(tier.minimum) * 100) return;
        (tier.products || []).forEach(product => {
          const variant = product.variants?.[0];
          if (!variant?.id || declined.includes(`${tier.id}:${product.id}`)) return;
          if (cart.items.some(item => item.product_id === product.id)) return;
          gifts.push({id: variant.id, quantity: 1, properties: {_attribution: 'Rebuy Tiered Progress Bar', _source: 'Rebuy', _tier: tier.id}});
        });
      });
      if (!gifts.length) return;
      const controller = new AbortController(), timer = setTimeout(() => controller.abort(), 5000);
      try {
        const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, {method:'POST', credentials:'same-origin', headers:{'Content-Type':'application/json'}, body:JSON.stringify({items:gifts}), signal:controller.signal});
        if (!response.ok) throw new Error(`Gift restore failed (${response.status})`);
      } finally { clearTimeout(timer); }
      await refresh();
    } catch (error) { console.warn('[caene-gift-guard]', error); }
  }
  async function checkAndContinue(action, checkout) {
    try {
      const cart = await refresh();
      const invalid = cart.items.find(item => quantityFor(item) && item.quantity !== quantityFor(item));
      if (invalid) { showError(`Your ${invalid.product_title} subscription needs ${quantityFor(invalid)} pouches per delivery. Remove this item and select your delivery option again before checkout.`, checkout);return; }
      await ensureGift(cart);
      document.getElementById('caene-plan-cart-error')?.remove();
      replay = true; try { action(); } finally { replay = false; }
    } catch { showError('We could not verify your delivery options. Please try checkout again.', checkout); }
  }
  document.addEventListener('click', event => {
    if (replay) return;
    const control = event.target.closest('.rebuy-cart__flyout-item-quantity-widget-button, quantity-input button');
    if (control?.closest('[data-caene-fixed-plan]')) { event.preventDefault();event.stopImmediatePropagation();return; }
    const checkout = event.target.closest('.rebuy-cart__checkout-button, .rebuy-cart__shop-pay-button, [name="checkout"], a[href*="/checkout"]');
    if (!checkout || checkout.disabled) return;
    event.preventDefault();event.stopImmediatePropagation();checkAndContinue(() => checkout.click(), checkout);
  }, true);
  document.addEventListener('submit', event => {
    if (replay || !(event.submitter?.name === 'checkout' || /\/checkout(?:\?|$)/.test(event.target.action))) return;
    event.preventDefault();event.stopImmediatePropagation();
    const form = event.target, submitter = event.submitter;checkAndContinue(() => form.requestSubmit(submitter), submitter || form);
  }, true);
  let scheduled = false;
  const observer = new MutationObserver(() => {
    if (scheduled) return;scheduled = true;requestAnimationFrame(() => { scheduled = false;render(); });
  });
  const init = () => { observer.observe(document.body,{childList:true,subtree:true});refresh().catch(() => {}); };
  document.addEventListener('rebuy:cart.change', () => refresh().catch(() => {}));
  document.addEventListener('rebuy:smartcart.show', () => refresh().catch(() => {}));
  document.addEventListener('change', event => {
    if (event.target.closest('cart-items, cart-drawer-items')) setTimeout(() => refresh().catch(() => {}),800);
  });
  document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded',init,{once:true}) : init();
})();
